module.exports = __webpack_public_path__ + "media/images/new-ui-images/hospital-regular-668435ff2529f1b092480d2d8c23d971.svg";